import React from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Tooltip } from 'components';
import { useRouterStore } from 'apps/hooks';
import { ShipmentQuoteNavigate } from 'apps/shipmentQuote/utils';
import { graphqlIdToDgraphId } from 'utils/dgraphId';

interface ShipmentQuoteButtonProps {
  conn: any;
}

const onlyUnique = (value: any, index: number, self: Array<any>) => {
  return self.indexOf(value) === index;
};

const ShipmentQuoteButton = observer(({ conn }: ShipmentQuoteButtonProps) => {
  const routerStore = useRouterStore();

  const selectedRFQs = [...conn.selectedRows];
  const selectedIds = selectedRFQs.map(rfqModel =>
    graphqlIdToDgraphId(rfqModel.id).slice(2),
  );

  const uniqueCustomers = selectedRFQs
    .map(rfq => rfq.customerSpace)
    .filter(onlyUnique);
  const isButtonDisabled = uniqueCustomers.length !== 1;

  const handleButtonClick = () => {
    const slug = selectedRFQs[0].customerSpace.path;
    ShipmentQuoteNavigate(routerStore, {
      customerSlug: slug,
      rfqids: selectedIds,
    });
  };

  return (
    <>
      <Box
        data-for='shipment-quote-btn'
        data-tip='Select one or more RFQs via the checkboxes on the left, to create a quote.'
      >
        <Button
          disabled={isButtonDisabled}
          onClick={handleButtonClick}
          text='Create Quote'
          size='small'
          icon='arrow_right'
          iconPosition='right'
        />
      </Box>
      <Tooltip delayShow={200} place='top' id='shipment-quote-btn' />
    </>
  );
});

export { ShipmentQuoteButton };
